module.exports = __webpack_public_path__ + "img/yaci.fe8c11a9.png";